import { Grid } from "~/components/UI";
import BaseCard from "./BaseCard";
import PaymentDuration from "./Charts/PaymentDuration";
import { eTimeInterval } from "./TimeIntervalSelector";
import { useTranslation } from "react-i18next";
import usePermissions from "~/hook/usePermissions";
import { PERMISSION } from "~/api/permissions/enums";

interface PSPPaymentDurationCardProps {
  title?: string;
  onUpdate: (
    queryParams: any
  ) => Promise<MetricsAPI.PSPPaymentDuratioResponceDto | undefined>;
}

const PSPPaymentDurationCard = ({
  title,
  onUpdate,
}: PSPPaymentDurationCardProps) => {
  const { t } = useTranslation();
  const { hasAll } = usePermissions();

  if (!hasAll(PERMISSION.READ_PSP_PAYMENT_DURATION_METRICS)) return null;

  return (
    <Grid item lg={12} xl={6}>
      <BaseCard
        title={title || "PSP Payment Duration"}
        timeIntervals={[eTimeInterval.LAST_HOUR, eTimeInterval.LAST_24_HOURS]}
        onUpdate={onUpdate}
      >
        {(data) =>
          data ? (
            <PaymentDuration
              period={data.period}
              list={data.list}
              yAxis={t("title.PSPPaymentDuration")}
            />
          ) : null
        }
      </BaseCard>
    </Grid>
  );
};

export default PSPPaymentDurationCard;
